import { ScreenshareBoardState } from 'features/content-whiteboard/utils/contentBoardStateManager';

export const formatScreenshareBoardState = (state: ScreenshareBoardState) => {
  if (!state) {
    return [];
  }

  return state.map(({ data }) => data);
};
